// extracted by mini-css-extract-plugin
module.exports = {"logo":"Booking_logo__3O4EG","item":"Booking_item__2SXJ-","price":"Booking_price__3NrvB","hotelDetails":"Booking_hotelDetails__4zdXd"};